export function FontColor (pEditor)
{
  let prevForeColor;


  function getCurrentForeColor ()
  {
    let foreColor;

    if (BEditor.browser.isIE && ((pEditor.pToolbar && pEditor.pToolbar.isMouseDown) || pEditor.isDropdownOpen) && prevForeColor != null)
    {
      return prevForeColor;
    }

    foreColor = pEditor.style.helpers.getCurrentStyleInRange('color') || '';

    prevForeColor = foreColor;
    return foreColor;
  }


  this.openForeColorDropdown = (pButton) =>
  {
    pEditor.pDropdown = pButton.getDropdown();

    if (!pEditor.pDropdown)
      return false;

    if (pEditor.pDropdown.getState())
    {
      pEditor.closeDropdown(pButton);
    }
    else
    {
      pEditor.pDropdown.setReturnedParameters('selectedStyleId', getCurrentForeColor() || 'rgba(0,0,0)');
      pEditor.openDropdown(pButton, pEditor.pDropdown, 'setForeColor');
    }
  };


  function setForeColor (pButton)
  {
    let i,
        pParameters,
        foreColorIds,
        elements,
        attrColor,
        currentRange,
        parentElement = null,
        fontElement;

    pEditor.pDropdown = pButton.getDropdown();

    if (pEditor.pDropdown)
    {
      pParameters = pEditor.pDropdown.getReturnedParameters();
    }

    if (pParameters && pParameters.selectedStyleId != null)
    {
      foreColorIds = pParameters.selectedStyleId;
    }

    pEditor.closeDropdown(pButton);

    if (foreColorIds != null)
    {
      pEditor.range.stopCheckSelection();

      if (foreColorIds.trim() === '')
      {
        foreColorIds = '010001';
      }
      else if (foreColorIds.toLowerCase().indexOf('transparent') === -1)
      {
        foreColorIds = '#' + foreColorIds;
      }
      else
      {
        foreColorIds = '010001';
      }

      if (BEditor.browser.isGecko)
      {
        currentRange = pEditor.range.getCurrent();
        parentElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.startContainer, new RegExp('A', 'i')) || pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.endContainer, new RegExp('A', 'i'));
      }

      if (!BEditor.browser.isIE)
      {
        pEditor.iFrameDoc.execCommand('styleWithCSS', false, false);
      }

      pEditor.iFrameDoc.execCommand('forecolor', false, foreColorIds);

      if (parentElement)
      {
        fontElement = parentElement.parentNode;

        if(fontElement.nodeName === 'FONT' && fontElement.innerHTML === parentElement.outerHTML)
        {
          fontElement.removeChild(parentElement);
          fontElement.innerHTML = parentElement.innerHTML;
          parentElement.innerHTML = fontElement.outerHTML;
          fontElement.outerHTML = parentElement.outerHTML;
        }
      }

      if (foreColorIds === '010001')
      {
        elements = pEditor.iFrameDoc.body.getElementsByTagName('FONT');

        for (i = elements.length; i--;)
        {
          attrColor = elements[i].getAttribute('color');

          if (attrColor && attrColor.indexOf('010001') !== -1)
          {
            elements[i].removeAttribute('color');
          }
        }
      }

      pEditor.range.restoreBookmark();
    }
    else
    {
      return false;
    }
  }


  this.getCurrentForeColor = getCurrentForeColor;
  this.setForeColor = setForeColor;
}